export const profileConstants = {
    LOAD_PROFILE_START: 'PROFILE:LOAD_START',
    LOAD_PROFILE_SUCCESS: 'PROFILE:LOAD_SUCCESS',
    LOAD_RESIDENTIAL_BASIS_SUCCESS: 'LOAD_RESIDENTIAL_BASIS_SUCCESS',
    EDIT_PROFILE_UPDATE: 'PROFILE:EDIT_UPDATE',
    SAVE_ADDRESS: 'PROFILE:SAVE_ADDRESS',
    SAVE_LANGUAGE: 'PROFILE:SAVE_LANGUAGE', 
    SAVE_ADDRESS_SUCCESS: 'PROFILE:SAVE_ADDRESS_SUCCESS',
    SAVE_RESIDENTIAL_BASIS_SUCCESS: 'PROFILE:SAVE_RESIDENTIAL_BASIS_SUCCESS',
    GENERIC_FAILURE: 'PROFILE:GENERIC_FAILURE',
    SAVE_EXTENDED_PROFILE_START:"EXTENDED_PROFILE:SAVE_START",
    SAVE_EXTENDED_PROFILE_SUCCESS:"EXTENDED_PROFILE:SAVE_SUCCESS",
    TOGGLE_LANGUAGE_SUCCESS:"EXTENDED_PROFILE:TOGGLE_LANGUAGE_SUCCESS",
    CLEAN_PROFILE_STATE:"CLEAN_PROFILE_STATE",
};



// WEBPACK FOOTER //
// ./src/_constants/profile.constants.js